/*
  Alohi Sparkling Social landing page (sections/alohi-social-bogo.liquid). Vanilla JS, loaded deferred.

  Buying, with the section's cart on (default):
    - pack-size forms ([data-sb-buy]) and buy links ([data-sb-claim]) add with the Ajax Cart API, so Shopify's
      standard add-to-cart event reaches the Meta and GA4 pixels, store the visit's UTMs and fbclid as cart
      attributes (they show on the order), refresh the header count and open the page's cart drawer;
    - the drawer lists the cart from /cart.js, changes quantities with /cart/change.js and links to checkout.
  With the cart off, a buy click empties the cart, adds that one item and opens checkout (?discount=CODE when set).
  Without JS the forms post to /cart/add and the links are cart permalinks.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-sb-root]');
  if (!root) return;

  var base = root.getAttribute('data-root') || '/';
  if (base.slice(-1) !== '/') base += '/';
  var cartEnabled = root.hasAttribute('data-sb-cart-enabled');
  var currency = root.getAttribute('data-currency') || 'USD';
  var removeLabel = root.getAttribute('data-remove-label') || 'Remove';

  /* ---- offer end: hide the offer bar and deadline lines once the date passes (covers cached pages) ---- */
  var endsAt = Number(root.getAttribute('data-ends-at') || 0) * 1000;
  if (endsAt && Date.now() > endsAt) {
    root.querySelectorAll('[data-sb-deadline], [data-sb-offer]').forEach(function (el) {
      el.hidden = true;
    });
  }

  /* ---- UTMs: keep the first values seen this session ---- */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid'];
  var utm = {};
  try {
    utm = JSON.parse(window.sessionStorage.getItem('alohiSbUtm') || '{}') || {};
  } catch (e) {
    utm = {};
  }
  var params = new URLSearchParams(window.location.search);
  UTM_KEYS.forEach(function (key) {
    var value = params.get(key);
    if (value && !utm[key]) utm[key] = value.slice(0, 250);
  });
  try {
    window.sessionStorage.setItem('alohiSbUtm', JSON.stringify(utm));
  } catch (e) {
    /* private mode: attributes still use this page's URL */
  }
  function cartAttributes() {
    var attributes = { landing_page: window.location.pathname };
    Object.keys(utm).forEach(function (key) {
      attributes[key] = utm[key];
    });
    return attributes;
  }

  /* ---- Ajax Cart API ---- */
  function request(path, body) {
    return fetch(base + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var error = new Error(data && (data.description || data.message) ? data.description || data.message : path);
          error.status = response.status;
          throw error;
        }
        return data;
      });
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function track(source, variantId, quantity) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'social_landing_add_to_cart', sb_cta: source, sb_variant: variantId, sb_quantity: quantity });
  }

  /* add one item; resolves when the cart drawer shows the new cart (or checkout opens with the cart off) */
  function addItem(variantId, quantity, code) {
    if (!cartEnabled) {
      return request('cart/clear.js', {})
        .then(function () {
          return request('cart/add.js', { items: [{ id: variantId, quantity: quantity }] });
        })
        .then(function () {
          return request('cart/update.js', { attributes: cartAttributes() });
        })
        .then(function () {
          window.location.href = base + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : '');
        });
    }
    return request('cart/add.js', { items: [{ id: variantId, quantity: quantity }] })
      .then(function () {
        return request('cart/update.js', { attributes: cartAttributes() });
      })
      .then(function (cart) {
        renderCart(cart);
        openCart();
      });
  }

  function setBusy(el, busy) {
    if (busy) {
      el.setAttribute('aria-busy', 'true');
      el.classList.add('is-loading');
    } else {
      el.removeAttribute('aria-busy');
      el.classList.remove('is-loading');
    }
  }

  /* buy links (variety pack card, single offers): data-variant / data-qty, permalink href as the fallback */
  root.addEventListener('click', function (event) {
    var link = event.target.closest('[data-sb-claim]');
    if (!link || event.defaultPrevented) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    var variantId = Number(link.getAttribute('data-variant'));
    if (!variantId) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    var quantity = Number(link.getAttribute('data-qty') || 1);
    setBusy(link, true);
    track(link.getAttribute('data-sb-cta') || '', variantId, quantity);
    addItem(variantId, quantity, link.getAttribute('data-discount') || '')
      .catch(function () {
        window.location.href = link.href;
      })
      .then(function () {
        setBusy(link, false);
      });
  });

  /* pack-size forms */
  function syncForm(form) {
    var chosen = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
    var button = form.querySelector('[data-sb-add]');
    if (!chosen || !button) return;
    var available = chosen.getAttribute('data-available') === 'true';
    button.disabled = !available;
    button.textContent = available ? button.getAttribute('data-add-label') : button.getAttribute('data-soldout-label');
    var error = form.querySelector('[data-sb-buy-error]');
    if (error) error.hidden = true;
  }
  root.querySelectorAll('[data-sb-buy]').forEach(function (form) {
    syncForm(form);
    form.addEventListener('change', function () {
      syncForm(form);
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var chosen = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      var button = form.querySelector('[data-sb-add]');
      if (!chosen || !button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
      var variantId = Number(chosen.value);
      setBusy(button, true);
      track('flavor_card', variantId, 1);
      addItem(variantId, 1, form.getAttribute('data-discount') || '')
        .catch(function (error) {
          var box = form.querySelector('[data-sb-buy-error]');
          if (box) {
            box.textContent = error.message || 'Something went wrong. Please try again.';
            box.hidden = false;
          }
        })
        .then(function () {
          setBusy(button, false);
        });
    });
  });

  /* a back-button return from checkout restores the page from cache with buttons still busy */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    root.querySelectorAll('[aria-busy="true"]').forEach(function (el) {
      setBusy(el, false);
    });
    if (cartEnabled) request('cart.js').then(renderCart).catch(function () {});
  });

  /* ---- cart drawer ---- */
  var drawer = root.querySelector('[data-sb-cart]');
  var panel = drawer ? drawer.querySelector('[role="dialog"]') : null;
  var itemsList = drawer ? drawer.querySelector('[data-sb-cart-items]') : null;
  var lastFocus = null;

  function renderCart(cart) {
    root.querySelectorAll('[data-sb-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    drawer.querySelector('[data-sb-cart-empty]').hidden = cart.item_count > 0;
    drawer.querySelector('[data-sb-cart-foot]').hidden = cart.item_count === 0;
    drawer.querySelector('[data-sb-cart-subtotal]').textContent = money(cart.total_price);
    itemsList.textContent = '';
    cart.items.forEach(function (item, index) {
      var line = index + 1;
      var li = document.createElement('li');
      li.className = 'sb-cart__item';

      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        img.alt = '';
        img.width = 64;
        img.height = 64;
        li.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'sb-cart__info';
      var title = document.createElement('p');
      title.className = 'sb-cart__name';
      title.textContent = item.product_title;
      info.appendChild(title);
      if (item.variant_title && !item.product_has_only_default_variant) {
        var variant = document.createElement('p');
        variant.className = 'sb-cart__variant';
        variant.textContent = item.variant_title;
        info.appendChild(variant);
      }

      var qty = document.createElement('div');
      qty.className = 'sb-cart__qty';
      [['-', item.quantity - 1, 'Decrease quantity'], ['+', item.quantity + 1, 'Increase quantity']].forEach(function (spec, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = spec[0] === '-' ? '\u2212' : '+';
        b.setAttribute('aria-label', spec[2] + ', ' + item.product_title);
        b.setAttribute('data-sb-line', line);
        b.setAttribute('data-sb-qty', spec[1]);
        qty.appendChild(b);
        if (i === 0) {
          var count = document.createElement('span');
          count.textContent = item.quantity;
          count.setAttribute('aria-label', 'Quantity ' + item.quantity);
          qty.appendChild(count);
        }
      });
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'sb-cart__remove';
      remove.textContent = removeLabel;
      remove.setAttribute('data-sb-line', line);
      remove.setAttribute('data-sb-qty', 0);
      qty.appendChild(remove);
      info.appendChild(qty);
      li.appendChild(info);

      var price = document.createElement('p');
      price.className = 'sb-cart__price';
      price.textContent = money(item.final_line_price);
      li.appendChild(price);

      itemsList.appendChild(li);
    });
  }

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    void drawer.offsetWidth; /* commit the closed position so the slide-in transition runs */
    drawer.classList.add('is-open');
    document.documentElement.classList.add('sb-cart-open');
    if (panel) panel.focus();
  }

  function closeCart() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('sb-cart-open');
    window.setTimeout(function () {
      drawer.hidden = true;
    }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (drawer) {
    root.querySelectorAll('[data-sb-cart-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        request('cart.js')
          .then(renderCart)
          .catch(function () {})
          .then(openCart);
      });
    });
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-sb-cart-close]')) {
        closeCart();
        return;
      }
      var change = event.target.closest('[data-sb-line]');
      if (!change) return;
      change.disabled = true;
      request('cart/change.js', { line: Number(change.getAttribute('data-sb-line')), quantity: Number(change.getAttribute('data-sb-qty')) })
        .then(renderCart)
        .catch(function () {
          change.disabled = false;
        });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeCart();
      if (event.key !== 'Tab' || drawer.hidden || !panel) return;
      var focusable = panel.querySelectorAll('a[href], button:not([disabled])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  /* ---- sticky phone button: in once the hero button scrolls away, out while the final band is on screen ---- */
  var sticky = root.querySelector('[data-sb-sticky]');
  var heroCta = root.querySelector('[data-sb-hero-cta]');
  var finalBand = root.querySelector('[data-sb-final]');
  if (sticky && heroCta && 'IntersectionObserver' in window) {
    var stickyLink = sticky.querySelector('a');
    var heroAbove = false;
    var finalVisible = false;
    var setSticky = function () {
      var show = heroAbove && !finalVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyLink) stickyLink.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      heroAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      setSticky();
    }).observe(heroCta);
    if (finalBand) {
      new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        setSticky();
      }).observe(finalBand);
    }
  }

  /* ---- optional 21+ gate (separate from the sitewide gate) ---- */
  var gate = root.querySelector('[data-sb-gate]');
  if (gate && root.hasAttribute('data-sb-age-gate')) {
    var KEY = 'alohiSocial21';
    var confirmed = false;
    try {
      confirmed = window.localStorage.getItem(KEY) === '1';
    } catch (e) {
      confirmed = false;
    }
    if (!confirmed) {
      gate.hidden = false;
      document.documentElement.classList.add('sb-gate-open');
      var gatePanel = gate.querySelector('[role="dialog"]');
      if (gatePanel) gatePanel.focus();
      gate.querySelector('[data-sb-gate-yes]').addEventListener('click', function () {
        try {
          window.localStorage.setItem(KEY, '1');
        } catch (e) {
          /* storage blocked: the gate shows again next visit */
        }
        gate.hidden = true;
        document.documentElement.classList.remove('sb-gate-open');
      });
      gate.querySelector('[data-sb-gate-no]').addEventListener('click', function () {
        gate.querySelector('[data-sb-gate-body]').hidden = true;
        gate.querySelector('[data-sb-gate-actions]').hidden = true;
        gate.querySelector('[data-sb-gate-denied]').hidden = false;
      });
    }
  }
})();
